const CHAT_BLK = 'ChatBlk';
export const UNAUTHORIZED_PRIMARY_MESSAGE = `You do not have access to ${CHAT_BLK}.`;
export const UNAUTHORIZED_SECONDARY_MESSAGE = `You are not authorized to access ${CHAT_BLK}. Contact your support team for further assistance.`;
export const UNABLE_TO_PERFORM_AUTHORIZATION_PRIMARY_MESSAGE = `${CHAT_BLK} is unavailable.`;
export const UNABLE_TO_PERFORM_AUTHORIZATION_SECONDARY_MESSAGE = `There was an error connecting. Try again later or contact your support team for further assistance.`;
